import {getFocusStyle, getTheme, ITheme, List, mergeStyleSets, Text} from "@fluentui/react";
import {useNavigate} from "react-router-dom";
import {useGetQuery, useListQuery} from "../../../../../services/erp-resource-api.service";
import useSafeQuery from "../../../../hooks/use-safe-query.hook";

const theme: ITheme = getTheme();
const {palette, semanticColors, fonts} = theme;

const classNames = mergeStyleSets({
    container: {
        overflow: "auto",
        // maxHeight: 500,
    },
    itemCell: [
        getFocusStyle(theme, {inset: -1}),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: "border-box",
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: "flex",
            selectors: {
                "&:hover": {background: palette.neutralLight},
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: "hidden",
        flexGrow: 1,
    },
    itemName: [
        fonts.medium,
        ,
        {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    ],
    itemIndex: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
    },
    chevron: {
        alignSelf: "center",
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});

const BasicStandardList = (props: any) => {

    const navigate = useNavigate()
    const {data} = useSafeQuery(useListQuery, {method: props.view_doc_type, fields: ['name', 'type'], filter: []})

    const onRenderCell: any = (
        item: any,
        index: number,
        isScrolling: boolean
    ): JSX.Element => {
        return (
            <div className={classNames.itemCell} data-is-focusable={true} onClick={() => {
                navigate(`/app/page/${props.page}?id=${item.name}`)
            }}>
                <div className={classNames.itemContent}>
                    <Text variant={'medium'}>{item.name}</Text>
                    <br/>
                    <Text variant={'xSmall'}>{item.type}</Text>
                </div>
            </div>
        );
    };

    const listMarkup = data && <List items={data.data} onRenderCell={onRenderCell}/>

    return (
        <>
            {listMarkup}
        </>
    )
}

export default BasicStandardList